import Carousel from '../../../node_modules/bootstrap/js/src/carousel'
import Collapse from '../../../node_modules/bootstrap/js/src/collapse'
import Dropdown from '../../../node_modules/bootstrap/js/src/dropdown'
import Modal from '../../../node_modules/bootstrap/js/src/modal'

import Filtering from "./components/Filtering"
import ImageSlider from "./components/ImageSlider"

function preloadSlideAndNeighbors(carouselEl, index) {
    if (!carouselEl) return;
    const items = carouselEl.querySelectorAll('.carousel-item');
    const total = items.length;
    if (total === 0) return;

    const indices = [
        index,
        (index - 1 + total) % total,
        (index + 1) % total
    ];

    for (const idx of indices) {
        const img = items[idx]?.querySelector('img[loading="lazy"]');
        if (img) {
            img.loading = 'eager';
        }
    }
}

document.addEventListener('show.bs.modal', (e) => {
    const modal = e.target;
    if (!modal || !modal.classList.contains('galleryElement--modal')) return;
    const carouselEl = modal.querySelector('.carousel');
    if (!carouselEl) return;
    const items = Array.from(carouselEl.querySelectorAll('.carousel-item'));
    const activeIdx = Math.max(0, items.findIndex((el) => el.classList.contains('active')));
    preloadSlideAndNeighbors(carouselEl, activeIdx);
});

document.addEventListener('slide.bs.carousel', (e) => {
    const carouselEl = e.target;
    if (!carouselEl || !carouselEl.closest('.galleryElement--modal')) return;
    if (typeof e.to === 'number') {
        preloadSlideAndNeighbors(carouselEl, e.to);
    }
});

document.addEventListener('keydown', (event) => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
        return;
    }
    const openModal = document.querySelector('.galleryElement--modal.show');
    if (!openModal) {
        return;
    }
    const carouselEl = openModal.querySelector('.carousel');
    if (!carouselEl) {
        return;
    }
    const carousel = Carousel.getOrCreateInstance(carouselEl);
    if (event.key === 'ArrowLeft') {
        event.preventDefault();
        carousel.prev();
    } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        carousel.next();
    }
});

export default {
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Filtering,
    ImageSlider
}

var cssRule1 =
    "color: rgb(1, 103, 150);" +
    "line-height: 1;" +
    "font-size: 20px;" +
    "font-weight: bold;";
var cssRule2 =
    "color: rgb(1, 103, 150);" +
    "line-height: 1;" +
    "font-size: 36px;" +
    "font-weight: bold;";
setTimeout(console.log.bind(console, "Built by"), 0);
setTimeout(console.log.bind(console, "%ccoastal\n%cC#DE", cssRule1, cssRule2), 0);
setTimeout(console.log.bind(console, "Visit: https://coastal-code.com/"), 0);
setTimeout(console.log.bind(console, "Email: info@coastal-code.com"), 0);
